import React, { Fragment } from 'react'
import { Dialog, Transition } from '@headlessui/react'
import { XIcon } from '@heroicons/react/solid'
import PropTypes from 'prop-types'
import Button from '../../../../../components/Button/Button'

const TermsAgreeModal = ({ isOpen, setIsOpen, onContinue }) => {
    const closeModal = () => {
        setIsOpen(!isOpen)
    }

    return (
        <>
            <Transition appear show={isOpen} as={Fragment}>
                <Dialog
                    as="div"
                    className="relative z-200"
                    onClose={closeModal}
                >
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <div className="fixed inset-0 bg-modalBackground bg-opacity-25" />
                    </Transition.Child>

                    <div className="fixed inset-0 overflow-y-auto">
                        <div className="flex min-h-full items-center justify-center p-4 text-center">
                            <Transition.Child
                                as={Fragment}
                                enter="ease-out duration-300"
                                enterFrom="opacity-0 scale-95"
                                enterTo="opacity-100 scale-100"
                                leave="ease-in duration-200"
                                leaveFrom="opacity-100 scale-100"
                                leaveTo="opacity-0 scale-95"
                            >
                                <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-3xl bg-white md:p-12 p-4 text-center transition-all relative flex flex-col items-center justify-start gap-y-6">
                                    <XIcon
                                        className="w-6 h-6 stroke-current absolute text-textDarkerGray top-6 right-6 cursor-pointer"
                                        onClick={closeModal}
                                    />
                                    <Dialog.Title
                                        as="h3"
                                        className="text-lg text-black90 font-semibold"
                                    >
                                        Technician Visit Fee
                                    </Dialog.Title>
                                    <p className="mt-1 text-textDarkGray text-sm font-normal text-left">
                                        Please note that a charge* will apply
                                        for dispatching a technician to assess
                                        the issue with your asset, even if no
                                        immediate repairs are made.
                                    </p>
                                    <p className="mt-1 text-textDarkGray text-sm font-normal text-left">
                                        The technician will provide a
                                        comprehensive report of the problem and
                                        an estimate for necessary repairs.
                                    </p>

                                    <div className="w-full flex items-center justify-center gap-4 ">
                                        <Button
                                            text="Cancel"
                                            variant="tertiary"
                                            onClick={() => {
                                                closeModal()
                                            }}
                                            className="w-full"
                                            type="button"
                                        />
                                        <Button
                                            text="Continue"
                                            variant="primary"
                                            onClick={() => {
                                                onContinue()
                                            }}
                                            className="w-full"
                                            type="button"
                                        />
                                    </div>
                                    <p className="font-medium text-sm text-textDarkGray">
                                        *Rate depends on your contract
                                    </p>
                                </Dialog.Panel>
                            </Transition.Child>
                        </div>
                    </div>
                </Dialog>
            </Transition>
        </>
    )
}

TermsAgreeModal.propTypes = {
    isOpen: PropTypes.bool,
    setIsOpen: PropTypes.func,
    onContinue: PropTypes.func,
}

export default TermsAgreeModal
